import axios from "axios";
const apiUrl = process.env.REACT_APP_DYRECT_API_URL_TWO;

export const getAudioFiles = async () => {
  try {
    const path="audio/files";
    const response = await axios.get(apiUrl+path);
    return response.data?.Data || [];
  } catch (error) {
    console.error("Error fetching audio files:", error);
    throw error;
  }
};

export const getMyAudioFiles = async (roomID) => {
    try {
        const path = "getMyAudioFiles";
        const response = await axios.post(apiUrl + path, { roomID });
        return response.data;
    } catch (error) {
        console.error('Error fetching user audio files from API:', error);
        throw error; 
    }
};

export const deleteExternalAudio = async (roomID, audioID) => {
    try {
        const path = "deleteExternalAudio";
        const response = await axios.post(apiUrl + path, { roomID, audioID });
        return response.data;
    } catch (error) {
        console.error('Error deleting audio file:', error);
        throw error;
    }
};